import React, { FC } from 'react';
import {
  Container,
  ContainerCollapse,
  Toggle,
  HeaderCaption,
  HeaderSubtitle,
  HeaderTitle
} from './styled';
import { Icon } from '../../../../../../../components';

interface IProps {
  error?: boolean;
  hideIndex?: boolean;
  index: number;
  isOk?: boolean;
  setShow: () => void;
  show: boolean;
  subtitle?: string;
  title: string;
}

const Collapsible: FC<IProps> = ({
  children,
  error,
  hideIndex,
  index,
  isOk,
  setShow,
  show,
  subtitle,
  title
}) => {
  const onChange = () => {
    setShow();
  };
  let color = 'var(--neutrals-neutral01)';
  if (isOk) color = 'var(--interaction-primary)';
  else if (error) color = 'var(--support-error)';

  let variantType = '';

  if (show) {
    variantType = 'show';
  } else if (isOk) {
    variantType = 'is-ok';
  }
  const indexPrefix = hideIndex ? '' : `${index}. `;
  const titleText = `${indexPrefix}${title}`;

  return (
    <Container>
      <Toggle
        onClick={onChange}
        color={color}
        className={show ? 'toggleOpen' : ''}
        height={'60px'}
      >
        <div className="toggleHeader">
          <HeaderCaption>
            <HeaderTitle variant={variantType} active={show}>
              {titleText}
            </HeaderTitle>
            <HeaderSubtitle if={subtitle}>{subtitle}</HeaderSubtitle>
          </HeaderCaption>
          <button type="button">
            <Icon name={show ? 'chevron-up' : 'chevron-down'} size={24} />
          </button>
        </div>
      </Toggle>
      <ContainerCollapse color={color} className="container-collapse">
        <div className={`toggle-content ${show ? 'expanded' : ''}`}>
          {children}
        </div>
      </ContainerCollapse>
    </Container>
  );
};

Collapsible.defaultProps = {
  error: false,
  isOk: false
};

export default Collapsible;
